import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
// Sentry disabled
// import * as Sentry from "@sentry/angular";

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// if (environment.production && environment.sentryEnabled) {
//   Sentry.init({
//     dsn: "",
//     integrations: [
//       Sentry.browserTracingIntegration(),
//       Sentry.browserProfilingIntegration(),
//     ],
//     tracesSampleRate: 1.0,
//   });
// }

if (environment.production) {
  enableProdMode();
  // Dynamically inject GTM only in production to avoid separate index variants
  const gtmId = 'GTM-5FHVRT45';
  (window as any).dataLayer = (window as any).dataLayer || [];
  const gtmScript = document.createElement('script');
  gtmScript.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${gtmId}');`;
  document.head.prepend(gtmScript);
  const noScript = document.createElement('noscript');
  noScript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
  // Defer noscript append until body is available
  if (document.body) {
    document.body.prepend(noScript);
  } else {
    window.addEventListener('DOMContentLoaded', () => document.body.prepend(noScript));
  }
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
